import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

// Goes back within our own in-app navigation stack. If the current entry has
// no prior in-app history (e.g. the user landed here via a deep link and the
// route was reached with `replace`), `navigate(-1)` would fall through to the
// browser's native back and take the user out of the app entirely. In that
// case we redirect to `fallback` instead.
export function useSafeGoBack(fallback = "/sites") {
  const navigate = useNavigate();

  return useCallback(() => {
    const idx = (window.history.state?.idx as number | undefined) ?? 0;
    if (idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  }, [navigate, fallback]);
}
